/**
 * Pipe utility for chaining functions left-to-right
 * More readable than nested function calls
 *
 * @example
 * const enhance = pipe(fn1, fn2, fn3)
 * enhance(value) // equivalent to fn3(fn2(fn1(value)))
 */
export const pipe = <T>(...fns: Array<(arg: T) => T>) => {
  return (value: T): T => {
    return fns.reduce((acc, fn) => fn(acc), value)
  }
}

/**
 * Alias for pipe - more semantic for enhancer functions
 */
export const pipeEnhancers = pipe
